import React from 'react';
import {
    Box,
    Container,
    Typography,
    Link,
    Stack,
} from '@mui/material';

const Footer = () => {
    return (
        <Box 
            component="footer" 
            sx={{ 
                py: 8,
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #E5E5E7',
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'center', md: 'flex-start' }}
                    spacing={4}
                >
                    {/* Contact Info */}
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#86868B',
                                fontSize: '1rem',
                                mb: 1,
                            }}
                        >
                            contact@aidex.co
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#86868B',
                                fontSize: '1rem',
                            }}
                        >
                            +43 624 396 758
                        </Typography>
                    </Box>

                    {/* Legal Links */}
                    <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        spacing={{ xs: 1, md: 3 }}
                        alignItems="center"
                    >
                        <Link
                            href="/docmate-privacy-policy"
                            underline="hover"
                            sx={{
                                color: '#86868B',
                                fontSize: '1rem',
                                textDecoration: 'none',
                                '&:hover': {
                                    color: '#007AFF',
                                },
                            }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            href="/terms-of-service"
                            underline="hover"
                            sx={{
                                color: '#86868B',
                                fontSize: '1rem',
                                textDecoration: 'none',
                                '&:hover': {
                                    color: '#007AFF',
                                },
                            }}
                        >
                            Terms of Service
                        </Link>
                    </Stack>

                    {/* Copyright */}
                    <Box sx={{ textAlign: { xs: 'center', md: 'right' } }}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#86868B',
                                fontSize: '1rem',
                            }}
                        >
                            © {new Date().getFullYear()} aidex.co
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default Footer;
